"use strict";

import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ClockRange from "terriajs-cesium/Source/Core/ClockRange";
import { withTranslation } from "react-i18next";
import Styles from "./timeline-controls.scss";
import Icon from "../../../Styled/Icon";
import { Category, TimeLineAction } from "../../../Core/AnalyticEvents/analyticEvents";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TimelineControls = createReactClass({
  displayName: "TimelineControls",
  propTypes: {
    clock: PropTypes.object.isRequired,
    analytics: PropTypes.object.isRequired,
    currentViewer: PropTypes.object.isRequired,
    locale: PropTypes.object,
    t: PropTypes.func.isRequired
  },
  getInitialState() {
    return {
      currentTimeString: ""
    };
  },
  gotoStart() {
    var _this$props$analytics;
    (_this$props$analytics = this.props.analytics) === null || _this$props$analytics === void 0 || _this$props$analytics.logEvent(Category.timeLine, TimeLineAction.gotoStart);
    this.props.clock.currentTime = this.props.clock.startTime;
    this.props.currentViewer.notifyRepaintRequired();
  },
  togglePlay() {
    var _this$props$analytics2;
    (_this$props$analytics2 = this.props.analytics) === null || _this$props$analytics2 === void 0 || _this$props$analytics2.logEvent(Category.timeLine, TimeLineAction.togglePlay);
    this.props.clock.tick();
    if (this.props.clock.multiplier < 0) {
      this.props.clock.multiplier = -this.props.clock.multiplier;
    }
    this.props.clock.shouldAnimate = !this.props.clock.shouldAnimate;
    this.props.currentViewer.notifyRepaintRequired();
  },
  playSlower() {
    var _this$props$analytics3;
    (_this$props$analytics3 = this.props.analytics) === null || _this$props$analytics3 === void 0 || _this$props$analytics3.logEvent(Category.timeLine, TimeLineAction.playSlower);
    this.props.clock.tick();
    this.props.clock.multiplier /= 2;
    this.props.clock.shouldAnimate = true;
    this.props.currentViewer.notifyRepaintRequired();
  },
  playFaster() {
    var _this$props$analytics4;
    (_this$props$analytics4 = this.props.analytics) === null || _this$props$analytics4 === void 0 || _this$props$analytics4.logEvent(Category.timeLine, TimeLineAction.playFaster);
    this.props.clock.tick();
    this.props.clock.multiplier *= 2;
    this.props.clock.shouldAnimate = true;
    this.props.currentViewer.notifyRepaintRequired();
  },
  toggleLoop() {
    var _this$props$analytics5;
    (_this$props$analytics5 = this.props.analytics) === null || _this$props$analytics5 === void 0 || _this$props$analytics5.logEvent(Category.timeline, TimeLineAction.toggleLoop);
    if (this.isLooping()) {
      this.props.clock.clockRange = ClockRange.CLAMPED;
    } else {
      this.props.clock.clockRange = ClockRange.LOOP_STOP;
    }
  },
  isLooping() {
    return this.props.clock.clockRange === ClockRange.LOOP_STOP;
  },
  isPlaying() {
    return this.props.clock.shouldAnimate;
  },
  render() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.controls,
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        className: Styles.timelineControl,
        onClick: this.gotoStart,
        title: t("dateTime.timeline.gotoStart"),
        children: /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.backToStart
        })
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: Styles.timelineControl,
        onClick: this.togglePlay,
        title: t("dateTime.timeline.togglePlay"),
        children: this.isPlaying() ? /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.pause
        }) : /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.play
        })
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: Styles.timelineControl,
        onClick: this.playSlower,
        title: t("dateTime.timeline.playSlower"),
        children: /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.backward
        })
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: Styles.timelineControl,
        onClick: this.playFaster,
        title: t("dateTime.timeline.playFaster"),
        children: /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.forward
        })
      })]
    });
  }
});
export default withTranslation()(TimelineControls);